import React, { useEffect, useState, useContext } from 'react';
import { ask__ } from '../../shared/utils/i18n.js';

import Loader from '../Loader/Loader.jsx';

import { findClient, saveClient } from './../../shared/utils/api.js';
import { GlobalErrorContext } from './../../shared/context/GlobalErrorContext.js';
import { GlobalIsRegisteredContext } from '../../shared/context/GlobalIsRegistered.js';
import { GlobalUserContext } from '../../shared/context/GlobalUserContext.js';

import './Register.scss';

/**
 * Used for both registering and editing user info
 */
export default function Register(props) {

  const {setGlobalError} = useContext(GlobalErrorContext);
  const {getGlobalIsRegistered, setGlobalIsRegistered} = useContext(GlobalIsRegisteredContext);
  const {getGlobalUser} = useContext(GlobalUserContext);

  const [isLoading, setIsLoading] = useState(false);

  const [getFirstName, setFirstName] = useState('');
  const [getLastName, setLastName] = useState('');
  const [getPhone, setPhone] = useState('');
  const [getEmail, setEmail] = useState('');
  const [getAddress, setAddress] = useState('');
  const [getZip, setZip] = useState('');
  const [getCity, setCity] = useState('');
  const [getLang, setLang] = useState(null);

  useEffect(() => {

    (async () => {

      if (!getGlobalUser.isLoggedIn) {
        setGlobalError({
          isError: true,
          errorCode: 'RL011'
        });
        return false;
      }

      // autofill values
      if (getGlobalIsRegistered) {

        setIsLoading(true);

        try {
          const client = await findClient();
          if (client && client.idString) {
            setFirstName(client.firstName);
            setLastName(client.lastName);
            setPhone(client.phone);
            setEmail(client.email);
            setAddress(client.address);
            setZip(client.postcode);
            setCity(client.city);
            setLang(client.lang);
          }

        } catch(err) {
          console.error(err);
          setGlobalError({
            isError: true,
            errorCode: 'RCL411'
          });
        }

        setIsLoading(false);

      } else {

        if (getGlobalUser.givenName !== '') {
          // givenName has all first names so split for first
          setFirstName(getGlobalUser.givenName.split(" ")[0]);
        }
        if (getGlobalUser.lastName !== '') {
          setLastName(getGlobalUser.lastName);
        }


      }

    })();

  }, []); // runs only on mount

  const handleRegister = event => {
    event.preventDefault();

    setIsLoading(true);

    (async () => {

      // save as formdata to be accessible with $_POST
      const payload = {
        'isRegistered': getGlobalIsRegistered,
        'personId': getGlobalUser.personId,
        'firstName': getFirstName,
        'lastName': getLastName,
        'phone': getPhone,
        'email': getEmail,
        'address': getAddress,
        'zip': getZip,
        'city': getCity,
        'lang': getLang
      };

      try {
        const client = await saveClient(payload);
        console.log('client', client);
        if (client && client.data.saved == 1) {
          setGlobalIsRegistered(true);
          if (typeof props.onSave == "function") {
            props.onSave();
          }
        } else {
          setGlobalError({
            isError: true,
            errorCode: 'RSC110'
          });
        }

      } catch(err) {
        console.error(err);
        setGlobalError({
          isError: true,
          errorCode: 'RSC111'
        });
      }

      setIsLoading(false);

    })();

  }


  return (
    <div className="register">

      {getGlobalUser.isLoggedIn && isLoading ? <>
        <Loader />
      </> : ''}

      {getGlobalUser.isLoggedIn && !isLoading ? <>

        <div className="login__register">
          <h2>{ask__('Register: Title')}</h2>
          <form
            onSubmit={handleRegister}
            className="form form--register"
          >

            <div className="input">
              <label className="input__label">
                {ask__('Register: Person id')}
                <span className="input__required">*</span>
              </label>
              <input
                className="input__field"
                type="text"
                value={getGlobalUser.personId}
                disabled
              />
            </div>

            <div className="input">
              <label className="input__label">
                {ask__('Register: First name')}
                <span className="input__required">*</span>
              </label>
              <input
                type="text"
                required
                className="input__field"
                value={getFirstName}
                onChange={event => setFirstName(event.target.value)}
              />
            </div>

            <div className="input">
              <label className="input__label">
                {ask__('Register: Last name')}
                <span className="input__required">*</span>
              </label>
              <input
                type="text"
                required
                className="input__field"
                value={getLastName}
                onChange={event => setLastName(event.target.value)}
              />
            </div>

            <div className="input">
              <label className="input__label">
                {ask__('Register: Phone')}
                <span className="input__required">*</span>
              </label>
              <input
                type="tel"
                required
                className="input__field"
                value={getPhone}
                onChange={event => setPhone(event.target.value)}
              />
            </div>

            <div className="input">
              <label className="input__label">
                {ask__('Register: Email')}
              </label>
              <input
                type="email"
                className="input__field"
                value={getEmail}
                onChange={event => setEmail(event.target.value)}
              />
            </div>

            <div className="input">
              <label className="input__label">
                {ask__('Register: Address')}
                <span className="input__required">*</span>
              </label>
              <input
                type="text"
                className="input__field"
                required
                value={getAddress}
                onChange={event => setAddress(event.target.value)}
              />
            </div>

            <div className="input">
              <label className="input__label">
                {ask__('Register: Zip')}
                <span className="input__required">*</span>
              </label>
              <input
                type="text"
                className="input__field"
                value={getZip}
                required
                size={5}
                maxLength={5}
                onChange={event => setZip(event.target.value)}
              />
            </div>

            <div className="input">
              <label className="input__label">
                {ask__('Register: City')}
                <span className="input__required">*</span>
              </label>
              <input
                type="text"
                required
                className="input__field"
                value={getCity}
                onChange={event => setCity(event.target.value)}
              />
            </div>

            <div className="input">
              <label className="input__label">
                {ask__('Register: Language')}
              </label>
              {[{'value': 'fi', 'label': 'Suomi'}, {'value': 'sv', 'label': 'Svenska'}, {'value': 'en', 'label': 'English'}].map((entry, i) => {
              return (
                <label className="input__radio-label">
                  <input
                    type="radio"
                    name="primary-color"
                    className={getLang === entry.value ? 'is-checked' : 'not-checked'}
                    value={entry.value}
                    checked={getLang === entry.value}
                    onChange={e => setLang(entry.value)}
                  />
                  <span className="input__radio-label__label">{entry.label}</span>
                </label>
              )
              })}
            </div>

            <button className="input__submit">
              {ask__('Register: Submit')}
            </button>



          </form>
        </div>

      </> : ''}

    </div>
  )

}
